import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {},
    header4: {
      ...theme.fonts.h4,
      marginTop: 104,
    },
    usernameSection: {
      marginTop: 17,
      "& > span": {
        ...theme.fonts.p2,
        color: theme.colors.textSubtle,
        marginLeft: 4,
      },
    },
    mfaCenter: {
      "& > div": {
        marginTop: "unset",
        width: "unset",
        minWidth: 360,
        marginBottom: "unset",
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
